import HeatMap from "react-heatmap-grid";
import { scaleSequential } from "d3-scale";
import { interpolateYlOrRd } from "d3-scale-chromatic"; 

const HeatmapGrid = ({xLabels, yLabels, data, xKey, yKey}) => {
  const maxValue = Math.max(...data.flat());
  const colorScale = scaleSequential(interpolateYlOrRd).domain([0, maxValue]);
  
  return (
    <div style={{ display: "grid", gridTemplateColumns: "50px auto" }}>
      <div style={{ writingMode: "vertical-rl", textAlign: "center", fontWeight: "bold" }}>
        {yKey}
      </div>
      <div>
        <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "8px" }}>
          {xKey}
        </div>
        <HeatMap 
          xLabels={xLabels} 
          yLabels={yLabels} 
          data={data} 
          cellRender={(value) => value && `${value}`}
          cellStyle={(background, value) => ({
            background: colorScale(value),
            color: value > maxValue * 0.6 ? "white" : "black",
            fontSize: "0.9rem",
          })}
          
        />
      </div>
    </div>
  )
}

export default HeatmapGrid